import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

export interface ISelectInputProps<T> {
    allowedValues: string[],
    label: string,
    value: T
    onChange: (value: T) => void;
}

export function SelectInput<T>(props: ISelectInputProps<T>) {

    const onChange = (event:SelectChangeEvent<T>) => {
        const value = event.target.value as T;
        props.onChange(value);
    }
    
    return (
        <FormControl style={{zIndex: 11000, width: "100%"}}>            
            <InputLabel id="selectinput-label">{props.label}</InputLabel>
            <Select
                MenuProps={{disablePortal: true}}
                labelId="selectinput-label"
                value={props.value}
                variant="standard"                        
                onChange={onChange}>                   
                {props.allowedValues.map( value => {
                    return (
                        <MenuItem key={value} value={value}>{value}</MenuItem>                        
                    )
                })}                     
            </Select>
        </FormControl>
    )
}